/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import * as React from 'react';
import { useSelector } from 'react-redux';

import styles from './styles.module.scss';
import Table from '../../components/Table';

const COLUMNS = [
  {
    Header: 'Email',
    accessor: 'email',
  },
  {
    Header: 'Amount',
    accessor: 'bonus_sum',
  },
];

const COLUMNS_WITHDRAW = [
  {
    Header: 'Date',
    accessor: 'updated_at',
  },
  {
    Header: 'Amount',
    accessor: 'amount',
  },
  {
    Header: 'Method',
    accessor: 'method',
  },
  {
    Header: 'Status',
    accessor: 'status',
  },
];

const ReferralHistory = () => {
  const [isReferralsTab, setIsReferralsTab] = React.useState(true);
  const { referralUsers, referralPayments } = useSelector((state) => state.profile);

  return (
    <div className={`${styles.box}`}>
      <div className={`${styles.mb15} ${styles.flexBetween}`}>
        <span className={styles.boxHeader}>Referrals history</span>
        <div className={styles.historySwitchBox}>
          <div
            className={`${styles.switchBoxButton} ${isReferralsTab ? styles.switchBoxButtonActive : styles.switchBoxButtonInactive}`}
            onClick={() => setIsReferralsTab(true)}
          >
            Referrals
          </div>
          <div
            className={`${styles.switchBoxButton} ${isReferralsTab ? styles.switchBoxButtonInactive : styles.switchBoxButtonActive}`}
            onClick={() => setIsReferralsTab(false)}
          >
            Payouts
          </div>
        </div>
      </div>
      <div>
        {isReferralsTab ? (
          <div>
            { referralUsers && (
              <Table
                data={referralUsers.referred_users ? referralUsers.referred_users : []}
                showPagination
                resizable={false}
                col={COLUMNS}
                defaultPageSize={10}
                showPaginationBottom={false}
                className="-striped -highlight"
                pages={referralUsers.referred_users ? referralUsers.referred_users.length / 10 : 1}
              />
            ) }
          </div>
        ) : (
          <div>
            { referralPayments && (
              <Table
                data={referralPayments.withdrawals ? referralPayments.withdrawals : []}
                showPagination
                resizable={false}
                col={COLUMNS_WITHDRAW}
                defaultPageSize={10}
                showPaginationBottom={false}
                className="-striped -highlight"
                pages={referralPayments.withdrawals ? referralPayments.withdrawals.length / 10 : 1}
              />
            ) }
          </div>
        )}
      </div>
    </div>
  );
};

export default ReferralHistory;
